import { data } from '../../svg/Settings/data';
import { makeIcon } from '../makeIcon';

export const Settings = makeIcon(data, 'settings', 'Settings');

export default Settings;
